import {CalculationsNotificationService} from "../../../opportunities_service/service/CalculationsNotificationService";
import {CalculationNotificationServiceName} from "../../../utils/names/serviceNames";
import {Opportunity} from "../../../opportunities/model/Opportunity";
import './customerOpportunities.scss';
import {Customer} from "../../../customers/model/Customer";
import {IPromise} from "angular";

interface OpportunitiesComponentScope extends ng.IScope {
    customerOpportunities: Opportunity[];
    hasOpportunities: boolean;
}

export class CustomerOpportunities implements ng.IComponentController {

    private $scope: OpportunitiesComponentScope;


    private customer: Customer;

    static instance: ng.IComponentOptions = {
        template: require('./customerOpportunities.html'),
        controller: ['$scope', CalculationNotificationServiceName, CustomerOpportunities],
        bindings: {
            'customer': '<'
        }
    };

    constructor($scope: OpportunitiesComponentScope,
                private calculationsNotificationService: CalculationsNotificationService) {
        this.$scope = $scope;
        $scope.customerOpportunities = [];
    }

    $onInit(): void {
        this.resolveCustomerOpportunities(this.customer.id);
    }

    resolveCustomerOpportunities = (customerId): IPromise<any> => {
        return this.calculationsNotificationService.getCustomerOpportunities(customerId)
            .then(resp => {
                if (resp.status === 200) {
                    let customerOpportunities = resp.data;
                    if (customerOpportunities.length) {
                        this.$scope.customerOpportunities = customerOpportunities;
                        this.$scope.hasOpportunities = true;
                    } else {
                        this.$scope.hasOpportunities = false;
                    }
                }
            });
    }

}